<div *ngIf="lastPage > 1" class="pages">
    <span (click)="clickPAge(p)" *ngFor="let p of pages" [class.active]="p===activePage" class="page">{{p}}</span>
</div>

